import React, { useState } from 'react';
import './Compare.scss';
import remove from '../../assets/remove.svg';
import info from '../../assets/compare-info.svg';
import compareInfo from '../../compareInfo';
import ComparePopUpInfo from './ComparePopUpInfo';

function Compare({
  savedData,
  setSavedData,
  showCompare,
  setShowCompare,
  currentData,
  savedDataArray,
  setSavedDataArray,
  setChecked,
  checked,
  ntlSup,
  ntlYoy,
  ntlAffor,
  ntlPop
}) {
  const [showInfoSupply, setShowInfoSupply] = useState(false);
  const [showInfoAppre, setShowInfoAppre] = useState(false);
  const [showInfoAfford, setShowInfoAfford] = useState(false);
  const [showInfoForecast, setShowInfoForecast] = useState(false);

  const removeFromSavedData = (e) => {
    let data = savedData;
    delete data[e];
    let check = Object.assign(checked);
    setSavedData(data);
    setSavedDataArray(Object.keys(data));
    delete check[e];
    setChecked(check);
  };

  return (
    <>
      {showCompare ? (
        <section className="compare">
          <div
            className="compare__x "
            onClick={() => {
              setShowCompare(false);
            }}
          >
            X
          </div>
          <div className="compare__contents">
            <div className="compare__fixed">
              <div className="compare__fixed__area__button">
                <button
                  className="compare__fixed__add"
                  onClick={() => {
                    setShowCompare(false);
                  }}
                >
                  + add
                </button>
              </div>
              <div className="compare__fixed__area">
                <div className="compare__fixed__area__title">
                  <p className="compare__fixed__area__title-text"> US Average</p>
                </div>
                {savedDataArray.map((area, i) => {
                  return (
                    <div className="compare__fixed__area__area" key={i}>
                      <p className="compare__fixed__area__names">
                        {currentData[area].name} ({currentData[area].abb})
                      </p>
                      <img
                        src={remove}
                        className="remove"
                        alt="remove"
                        onClick={() => {
                          removeFromSavedData(area);
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="table__container">
              <table className="table">
                <thead>
                  <tr>
                    <th className="table__head">
                      Housing Shortage
                      <img
                        className="definition"
                        src={info}
                        alt="more information"
                        onClick={
                          showInfoSupply
                            ? () => {
                                setShowInfoSupply(false);
                              }
                            : () => {
                                setShowInfoSupply(true);
                              }
                        }
                        onMouseEnter={() => {
                          setShowInfoSupply(true);
                        }}
                        onMouseLeave={() => {
                          setShowInfoSupply(false);
                        }}
                      />
                      {showInfoSupply ? (
                        <div className="">
                          <ComparePopUpInfo
                            setShowInfo={setShowInfoSupply}
                            data={compareInfo.supply}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </th>
                    <th className="table__head">
                      Home Price Appreciation
                      <img
                        className="definition"
                        src={info}
                        alt="more information"
                        onClick={
                          showInfoAppre
                            ? () => {
                                setShowInfoAppre(false);
                              }
                            : () => {
                                setShowInfoAppre(true);
                              }
                        }
                        onMouseEnter={() => {
                          setShowInfoAppre(true);
                        }}
                        onMouseLeave={() => {
                          setShowInfoAppre(false);
                        }}
                      />
                      {showInfoAppre ? (
                        <div className="">
                          <ComparePopUpInfo
                            setShowInfo={setShowInfoAppre}
                            data={compareInfo.appreciation}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </th>
                    <th className="table__head">
                      Affordability
                      <img
                        className="definition"
                        src={info}
                        alt="more information"
                        onClick={
                          showInfoAfford
                            ? () => {
                                setShowInfoAfford(false);
                              }
                            : () => {
                                setShowInfoAfford(true);
                              }
                        }
                        onMouseEnter={() => {
                          setShowInfoAfford(true);
                        }}
                        onMouseLeave={() => {
                          setShowInfoAfford(false);
                        }}
                      />
                      {showInfoAfford ? (
                        <div className="">
                          <ComparePopUpInfo
                            setShowInfo={setShowInfoAfford}
                            data={compareInfo.affordability}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </th>
                    <th className="table__head">
                      Housing Demand Forecast
                      <img
                        className="definition"
                        src={info}
                        alt="more information"
                        onClick={
                          showInfoForecast
                            ? () => {
                                setShowInfoForecast(false);
                              }
                            : () => {
                                setShowInfoForecast(true);
                              }
                        }
                        onMouseEnter={() => {
                          setShowInfoForecast(true);
                        }}
                        onMouseLeave={() => {
                          setShowInfoForecast(false);
                        }}
                      />
                      {showInfoForecast ? (
                        <ComparePopUpInfo
                          setShowInfo={setShowInfoForecast}
                          data={compareInfo.forecast}
                        />
                      ) : (
                        <></>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="table__average">
                    <td className="table__average__data">{ntlSup}</td>
                    <td className="table__average__data">{ntlYoy}%</td>
                    <td className="table__average__data">{ntlAffor}</td>
                    <td className="table__average__data">{ntlPop}%</td>
                  </tr>
                  {savedDataArray.map((area, i) => {
                    return (
                      <tr className="table__data" key={i}>
                        <td>{currentData[area].job}</td>
                        <td>{currentData[area].yoyChange}%</td>
                        <td>{currentData[area].hai}</td>
                        <td>{currentData[area].growth}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
}

export default Compare;
